import React, { Component } from 'react'
import { setAdminPage } from '../../action/action'
import { connect } from 'react-redux'
import DeviceReg from '../admin-device-registration/deviceReg'
import RoomSelector from './roomSelector'
import { deviceRegColorset } from '../../JS/setColors'

class AdminDeviceRegistration extends Component {

    componentDidMount() {
        deviceRegColorset(this.props.menuColor);
    }
    render() {
        return (
            <section id="app-body" className="col">
                <div id="ico-devReg" className="contentSection overUnder columns h-100 center-v">
                    <div id="devReg" className="col" style={{
                        background: "rgba(255,255,255,0.95)", marginRight: 0,
                        padding: "1rem", maxWidth: "30rem",
                        margin: "0 auto", height: "auto"
                    }}>
                        <div className="activity-heading all-caps"
                            style={{ color: "inherit"}}>{this.props.stringConst.deviceRegistration}</div>
                        {this.props.CorrectIP ?
                            <RoomSelector />
                            : <DeviceReg />
                        }
                    </div>
                </div>
            </section>
        )
    }
}

const mapStateToProps = state => {
    return {
        CorrectIP: state.store.deviceReg.CorrectIP,
        stringConst: state.store.home.stringConst,
        menuColor: state.store.home.MenuColor
    }
}

export default connect(
    mapStateToProps,
    {
        setAdminPage
    }
)(AdminDeviceRegistration);